module.exports = __webpack_public_path__ + "static/media/not-feeling-good-enough@3x.1f0642cd.png";